import Image from 'next/image';
import {useEffect} from 'react';

import styles from '@styles/contact-us/contact-us.module.scss';

const ContactUsPage = () => {
	useEffect(() => {
		const script = document.createElement('script');
		script.src = 'https://js.hsforms.net/forms/shell.js';
		document.body.appendChild(script);

		script.addEventListener('load', () => {
			if (window.hbspt) {
				window.hbspt.forms.create({
					region: 'na1',
					portalId: '47537090',
					formId: 'bd99f048-e239-4f60-a6bb-2a2595f51234',
					target: '#hubspotForm',
					onFormReady: form => {
						customizeHubSpotForm(form);
					},
				});
			}
		});

		const customizeHubSpotForm = form => {
			const submitButton = form.querySelector('input[type="submit"]');
			if (submitButton) {
				submitButton.style.marginTop = '-10px';
			}

			const viralityLink = form.querySelector('.hs-form__virality-link');
			if (viralityLink) viralityLink.remove();
		};
	}, []);

	return (
		<>
			<div
				style={{
					marginBottom: '3rem',
				}}
			>
				<div className={styles.contactPageSection}>
					<div className={styles.contactPageSection__Left}>
						<Image
							alt='contact us image'
							layout='fill'
							src={'/img/contact-us-image.png'}
						/>
					</div>
					<div className={styles.contactPageSection__Right}>
						<h1>Get in touch.</h1>
						<p>We'd love to hear from you.</p>
					</div>
				</div>
				<div className={styles.contactFormInfo}>
					<h2>Contact Ditybit</h2>
					<p>
						We'd love to hear from you. Get in touch via email at <br />
						support@ditybit.com <br /> or use the handy form below{' '}
						<img
							style={{
								height: '3rem',
							}}
							alt='laugh icon'
							src='https://cdnjs.cloudflare.com/ajax/libs/emojione/2.0.1/assets/svg/1f600.svg'
						/>
					</p>
				</div>
				<div className={styles.contactFormContainer}>
					<div className={styles.contactForm} id='hubspotForm'></div>
				</div>
			</div>
			<div id='dynamicstyle'></div>
		</>
	);
};

ContactUsPage.Layout = true;
export default ContactUsPage;
